import React from "react";

interface FontAwesomeProps {
  name: string;
  classname?: string;
}

/**
 * ✅ FontAwesome icon component (TypeScript version)
 * @param name - The FontAwesome icon name (without "fa-")
 * @param classname - Optional extra class names
 */
const FontAwesome: React.FC<FontAwesomeProps> = ({ name, classname = "" }) => {
  return <i className={`fa fa-${name} ${classname}`.trim()} />;
};

export default FontAwesome;
